// removed by extract-text-webpack-plugin
module.exports = {"loader":"spinner--loader--1BUVLhjr","isBlock":"spinner--isBlock--2WQ6zqng","isGreen":"spinner--isGreen--2PQWr9q1","path":"spinner--path--2TPCKRzn","isTransparent":"spinner--isTransparent--3uoobMgT","isActive":"spinner--isActive--2PfGgnM9","circular":"spinner--circular--1l5hujdJ","rotate":"spinner--rotate--1Sh6THec","dash":"spinner--dash--2NiPs-Sp"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Spinner/spinner.scss
// module id = 566
// module chunks = 0